@if (auth.isAuthenticated$() | async; as authenticated) {
	@if (authenticated) {
		<button [disabled]="!isOnline" ngbDropdownItem *ngIf="auth.user() | async as user" type="button" class="btn btn-secondary" (click)="onLogout()">
			<i class="bi bi-box-arrow-right"></i>&nbsp;<span>Abmelden</span>
		</button>
	} 
	@else {
		<button ngbDropdownItem type="button" class="btn btn-secondary" (click)="openLogin()">
			<i class="bi bi-person-circle"></i>&nbsp;<span>Anmelden</span>
		</button>
	}
}
@else {
	<button *ngIf="!auth.currentUser" [disabled]="!isOnline" ngbDropdownItem type="button" class="btn btn-secondary" (click)="openLogin()">
		<i class="bi bi-person-circle"></i>&nbsp;<span>Anmelden</span>
	</button>
	<button *ngIf="auth.currentUser" [disabled]="!isOnline" ngbDropdownItem type="button" class="btn btn-secondary" (click)="onLogout()">
		<i class="bi bi-person-circle"></i>&nbsp;<span>Abmelden</span>
	</button>
}
